// Central marketing content for the Which Media corporate site.

export const GROUP_STATS = [
  { value: "Multiple", label: "Specialist education brands", sub: "One trusted group" },
  { value: "7", label: "International markets", sub: "UAE · Saudi Arabia · UK · Singapore · Hong Kong · Thailand · Vietnam" },
  { value: "18,000+", label: "Parent enquiries mediated", sub: "Directly connected to schools" },
  { value: "2M+", label: "Parents reached each year", sub: "And growing rapidly" },
  { value: "2013", label: "Pioneering since", sub: "A decade defining the category" },
  { value: "#1", label: "Most trusted in the Gulf, SEA & Europe", sub: "Independent & parent-first" },
];

export const HISTORY = [
  { year: "2013", title: "WhichSchoolAdvisor.com launches", body: "The Gulf's first truly independent, parent-first school resource opens its doors in the UAE — built on in-depth, honest reviews." },
  { year: "2015/16", title: "SchoolsCompared.com arrives", body: "Side-by-side comparison and forensic reviews launch for the UAE — the world's largest international school market." },
  { year: "2016/17", title: "The Top Schools Awards begin", body: "The awards the UAE media would come to call 'the Oscars of education' recognise excellence for the first time." },
  { year: "2018+", title: "Expansion across continents", body: "WhichSchoolAdvisor.com scales into Singapore, the UK, Hong Kong, Thailand, Vietnam and Saudi Arabia — seven markets across three continents." },
  { year: "Today", title: "The Education Intelligence Group", body: "Data, consultancy and B2B analytics — EdinformaPlus and the EIG — turn a decade of insight into decisions for owners, investors and banks." },
  { year: "Soon", title: "WhichUniversityAdvisor.com", body: "The next chapter: bringing the same independent rigour to higher education worldwide." },
];

export const SOLUTIONS = [
  {
    key: "advertising",
    kicker: "For Advertisers & Schools",
    title: "Reach parents at the moment of decision",
    body: "Our audiences aren't browsing — they're choosing. When a family lands on a Which Media title, they are actively deciding where to invest in their child's future. That makes our platforms the single most valuable place in the region for schools and education brands to be seen, considered and chosen.",
    points: [
      "Premium display, sponsorship and native content across every title",
      "Direct access to high-intent parents in seven international markets",
      "Category-defining brand partnerships and the Top Schools Awards",
    ],
  },
  {
    key: "intelligence",
    kicker: "For Owners, Investors & Banks",
    title: "Data and consultancy you can build a business on",
    body: "Through EdinformaPlus and the Education Intelligence Group, we combine proprietary datasets, on-the-ground expertise and decades of UAE experience. When investors weigh spending upwards of US$30m on a new school, our unfettered, agenda-free analysis de-risks the decision.",
    points: [
      "Benchmark any school's performance against its true peers",
      "Due-diligence datasets for investors, operators and lenders",
      "Hands-on consultancy: business modelling to implementation",
    ],
  },
  {
    key: "editorial",
    kicker: "For Parents",
    title: "The truth, and nothing less",
    body: "Independent reviews. Real data. No agenda. Every guide, rating and comparison exists to get a parent to the last mile of the most important decision they will make for their child — with total confidence.",
    points: [
      "In-depth, independent reviews of every school we cover",
      "Side-by-side comparison of the stats that actually matter",
      "A 24/7 news desk and thriving parent community",
    ],
  },
];

export const VALUES = [
  { n: "01", title: "Independence, always", body: "We are beholden to no school, no group and no advertiser's agenda. Our reviews are earned, never bought — and that independence is the foundation of every reader's trust." },
  { n: "02", title: "Evidence over opinion", body: "We replace hearsay with proprietary data — fees, results, inspections and outcomes made clear and comparable — so every decision rests on fact." },
  { n: "03", title: "The parent comes first", body: "Behind every enquiry is a family making a life-defining choice. We write, rate and build for them, with clarity, honesty and genuine care for the child at the centre of it all." },
  { n: "04", title: "Excellence, celebrated", body: "Through the Top Schools Awards we spotlight the educators setting the standard — and, done credibly, recognition raises the bar for an entire sector." },
];
